// extracted by mini-css-extract-plugin
export var dropdown__categories = "transversal-nav-nojs-module--dropdown__categories--04de9";
export var dropdown__category = "transversal-nav-nojs-module--dropdown__category--62cea";
export var dropdown__header = "transversal-nav-nojs-module--dropdown__header--f580c";
export var dropdown__menu = "transversal-nav-nojs-module--dropdown__menu--d4238";
export var js = "transversal-nav-nojs-module--js--2755d";
export var lang__button = "transversal-nav-nojs-module--lang__button--b5635";
export var line__divider = "transversal-nav-nojs-module--line__divider--244f8";
export var list = "transversal-nav-nojs-module--list--230c7";
export var menu__item = "transversal-nav-nojs-module--menu__item--eb7a5";
export var modal = "transversal-nav-nojs-module--modal--52c8c";
export var nested__menu__title = "transversal-nav-nojs-module--nested__menu__title--582d8";
export var nested__sub__menu = "transversal-nav-nojs-module--nested__sub__menu--e0483";
export var nojs = "transversal-nav-nojs-module--nojs--bf690";
export var overlay = "transversal-nav-nojs-module--overlay--d2d48";
export var right__items = "transversal-nav-nojs-module--right__items--491b0";
export var search = "transversal-nav-nojs-module--search--7f127";
export var sub__menu__title = "transversal-nav-nojs-module--sub__menu__title--0722f";
export var wrapper__menu = "transversal-nav-nojs-module--wrapper__menu--2bb8f";